import { capitalize } from "lodash-es"
import { TagCategory } from "~/shared/types/tag-category"

const tagFilterLabel = (activeTagCategory: TagCategory) => capitalize(activeTagCategory.name.split('_')[1])

export default tagFilterLabel

